<template>
    <a-time-picker
        v-model="changeValue"
        style="width: 100%"
        :valueFormat="parameters.format"
        :format="parameters.format"
        :clearable="parameters.clearable"
        :placeholder="parameters.placeholder"
        @change="onChange" />
</template>

<script>
import { DataEntryMixin } from './mixins';
export default {
    name: 'SdTime',
    mixins: [DataEntryMixin],
    computed:{
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
    },
    data() {
        return {};
    },
    created() {},
    methods: {
        onChange(){

        }
    },
};
</script>

<style scoped lang="less"></style>
